(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function attachCheckboxListener() {
  var checkbox = document.getElementById('signup-checkbox-footer');
  var submitButton = document.getElementById('FooterSubscribe');

  if (checkbox && submitButton) {
    checkbox.removeEventListener('change', toggleSubmitButton);
    checkbox.addEventListener('change', toggleSubmitButton);

    submitButton.disabled = !checkbox.checked;
  }
}

function toggleSubmitButton() {
  var submitButton = document.getElementById('FooterSubscribe');
  if (submitButton) {
    submitButton.disabled = !this.checked;
  }
}

document.addEventListener('DOMContentLoaded', attachCheckboxListener);
document.addEventListener('shopify:section:select', attachCheckboxListener);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gm-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  const reviews = [
    {
      id: 1,
      name: "Priya Sharma",
      avatar: "PS",
      avatarClass: "avatar-1",
      rating: 5,
      review: "Absolute game changer! Palak Paneer Rice was so delicious 🤤 Quality is amazing, taste exactly like restaurant made. Will definitely buy again!",
      product: "Palak Paneer Rice",
      date: "2 days ago"
    },
    {
      id: 2,
      name: "Rohit Patel",
      avatar: "RP",
      avatarClass: "avatar-2",
      rating: 5,
      review: "Best ready-to-eat food I've ever tried. Dal Chawal was perfectly cooked. Recommended for busy professionals like me ⭐",
      product: "Dal Chawal",
      date: "4 days ago"
    },
    {
      id: 3,
      name: "Anjali Gupta",
      avatar: "AG",
      avatarClass: "avatar-3",
      rating: 4,
      review: "Rajma Chawal is really good! Packaging is premium and food quality is consistent. Little more masala would be perfect 😊",
      product: "Rajma Chawal",
      date: "1 week ago"
    },
    {
      id: 4,
      name: "Vikram Singh",
      avatar: "VS",
      avatarClass: "avatar-4",
      rating: 5,
      review: "Chole Chawal was outstanding! The taste and freshness exceeded my expectations. Such a convenient option for lunch 👍",
      product: "Chole Chawal",
      date: "5 days ago"
    },
    {
      id: 5,
      name: "Neha Kapoor",
      avatar: "NK",
      avatarClass: "avatar-5",
      rating: 5,
      review: "Tried Madras Pongal for first time - absolutely loved it! 🔥 Perfect spice level, best south Indian food at this price",
      product: "Madras Pongal",
      date: "3 days ago"
    },
    {
      id: 6,
      name: "Arjun Sharma",
      avatar: "AS",
      avatarClass: "avatar-1",
      rating: 4,
      review: "Sambhar Rice is delicious but wish portions were slightly bigger. Quality is premium though, keep it up! 💯",
      product: "Sambhar Rice",
      date: "1 week ago"
    },
    {
      id: 7,
      name: "Divya Reddy",
      avatar: "DR",
      avatarClass: "avatar-2",
      rating: 5,
      review: "Curd Rice - perfect comfort food! My kids loved it. So much better than making it at home ❤️",
      product: "Curd Rice",
      date: "6 days ago"
    },
    {
      id: 8,
      name: "Aditya Kumar",
      avatar: "AK",
      avatarClass: "avatar-3",
      rating: 5,
      review: "FoodInsta really understands quality. Dal Chawal is my go-to lunch now. Consistent taste, fresh delivery 👌",
      product: "Dal Chawal",
      date: "2 days ago"
    },
    {
      id: 9,
      name: "Shreya Malhotra",
      avatar: "SM",
      avatarClass: "avatar-4",
      rating: 5,
      review: "Ordered Rajma Chawal multiple times now. Every time it's fresh, hot, and delicious! 🔥 Best investment",
      product: "Rajma Chawal",
      date: "4 days ago"
    },
    {
      id: 10,
      name: "Karan Verma",
      avatar: "KV",
      avatarClass: "avatar-5",
      rating: 4,
      review: "Palak Paneer Rice is really nice. Would appreciate if packaging had reheating instructions 😊",
      product: "Palak Paneer Rice",
      date: "1 week ago"
    },
    {
      id: 11,
      name: "Pooja Singh",
      avatar: "PS",
      avatarClass: "avatar-1",
      rating: 5,
      review: "First time buying online food and FoodInsta impressed me! Chole Chawal was exactly as shown in pics ✨",
      product: "Chole Chawal",
      date: "5 days ago"
    },
    {
      id: 12,
      name: "Rahul Desai",
      avatar: "RD",
      avatarClass: "avatar-2",
      rating: 5,
      review: "Dal Makhani taste is restaurant quality! I'm shocked at how good it is for the price 🤩 Ordering again!",
      product: "Dal Makhani",
      date: "3 days ago"
    },
    {
      id: 13,
      name: "Meera Nair",
      avatar: "MN",
      avatarClass: "avatar-3",
      rating: 5,
      review: "Madras Pongal - pure love! The flavors are incredible and portions are perfect 😍 Highly recommended!",
      product: "Madras Pongal",
      date: "2 days ago"
    },
    {
      id: 14,
      name: "Sanjay Kumar",
      avatar: "SK",
      avatarClass: "avatar-4",
      rating: 4,
      review: "Sambhar Rice is amazing! Would give 5 stars but packaging could be better. Still highly satisfied 👍",
      product: "Sambhar Rice",
      date: "6 days ago"
    },
    {
      id: 15,
      name: "Riya Chopra",
      avatar: "RC",
      avatarClass: "avatar-5",
      rating: 5,
      review: "Curd Rice is exactly what I needed! Perfect after heavy meal. Fresh, tasty, and healthy 💚",
      product: "Curd Rice",
      date: "4 days ago"
    },
    {
      id: 16,
      name: "Nikhil Joshi",
      avatar: "NJ",
      avatarClass: "avatar-1",
      rating: 5,
      review: "FoodInsta never disappoints! Rajma Chawal is my lunch hero now. Taste is consistent every time 🎯",
      product: "Rajma Chawal",
      date: "1 week ago"
    },
    {
      id: 17,
      name: "Ananya Bhat",
      avatar: "AB",
      avatarClass: "avatar-2",
      rating: 5,
      review: "Palak Paneer Rice - wow! Quality of paneer and spinach is premium. Worth every rupee spent! 🌟",
      product: "Palak Paneer Rice",
      date: "3 days ago"
    },
    {
      id: 18,
      name: "Deepak Sharma",
      avatar: "DS",
      avatarClass: "avatar-3",
      rating: 4,
      review: "Dal Chawal good quality but shipping took 2 days. Product itself is 5 stars though! ⭐",
      product: "Dal Chawal",
      date: "5 days ago"
    },
    {
      id: 19,
      name: "Sakshi Pandey",
      avatar: "SP",
      avatarClass: "avatar-4",
      rating: 5,
      review: "Chole Chawal is absolutely delicious! My family loves it. This is regular food now 😋",
      product: "Chole Chawal",
      date: "2 days ago"
    },
    {
      id: 20,
      name: "Varun Rao",
      avatar: "VR",
      avatarClass: "avatar-5",
      rating: 5,
      review: "Dal Makhani creamy, rich, and perfect! Taste is exactly like my favorite restaurant ❤️ Superb!",
      product: "Dal Makhani",
      date: "4 days ago"
    },
    {
      id: 21,
      name: "Ishita Verma",
      avatar: "IV",
      avatarClass: "avatar-1",
      rating: 5,
      review: "Madras Pongal - best south Indian option available online! Love the authentic taste 🎉",
      product: "Madras Pongal",
      date: "1 week ago"
    },
    {
      id: 22,
      name: "Harsha Trivedi",
      avatar: "HT",
      avatarClass: "avatar-2",
      rating: 4,
      review: "Sambhar Rice is very tasty! Only thing - would like a sauce pouch separately for freshness 👌",
      product: "Sambhar Rice",
      date: "6 days ago"
    },
    {
      id: 23,
      name: "Radhika Nair",
      avatar: "RN",
      avatarClass: "avatar-3",
      rating: 5,
      review: "Curd Rice is my new favorite! Perfect blend of yogurt and rice. Tastes homemade 💕",
      product: "Curd Rice",
      date: "3 days ago"
    },
    {
      id: 24,
      name: "Manish Singh",
      avatar: "MS",
      avatarClass: "avatar-4",
      rating: 5,
      review: "Rajma Chawal quality is unbeatable! Consistent, fresh, and delicious every single order 🔥",
      product: "Rajma Chawal",
      date: "2 days ago"
    },
    {
      id: 25,
      name: "Swati Borah",
      avatar: "SB",
      avatarClass: "avatar-5",
      rating: 5,
      review: "Palak Paneer Rice - restaurant quality at doorstep! Best ready-to-eat product I've found ✨",
      product: "Palak Paneer Rice",
      date: "5 days ago"
    },
    {
      id: 26,
      name: "Adnan Khan",
      avatar: "AK",
      avatarClass: "avatar-1",
      rating: 4,
      review: "Dal Chawal is really good for daily lunch. Quality is consistent. More variety would be nice 😊",
      product: "Dal Chawal",
      date: "1 week ago"
    },
    {
      id: 27,
      name: "Navya Gupta",
      avatar: "NG",
      avatarClass: "avatar-2",
      rating: 5,
      review: "Chole Chawal is my protein source now! Fresh ingredients, great taste, love it! 💪",
      product: "Chole Chawal",
      date: "4 days ago"
    },
    {
      id: 28,
      name: "Siddharth Mallik",
      avatar: "SM",
      avatarClass: "avatar-3",
      rating: 5,
      review: "Dal Makhani is absolutely stunning! Butter, cream, flavors - everything is perfect 🌟",
      product: "Dal Makhani",
      date: "3 days ago"
    },
    {
      id: 29,
      name: "Kavya Deshmukh",
      avatar: "KD",
      avatarClass: "avatar-4",
      rating: 5,
      review: "Madras Pongal is authentic and delicious! Finally found good south Indian food online 🔥",
      product: "Madras Pongal",
      date: "2 days ago"
    },
    {
      id: 30,
      name: "Pranav Sharma",
      avatar: "PS",
      avatarClass: "avatar-5",
      rating: 5,
      review: "FoodInsta is my go-to! Every product is fresh and tasty. Highly recommend to everyone! 👍",
      product: "Sambhar Rice",
      date: "6 days ago"
    }
  ];

  function generateStars(rating) {
    let stars = '';
    for (let i = 0; i < 5; i++) {
      stars += i < rating ? '★' : '☆';
    }
    return stars;
  }

  function renderReviews(reviewsToShow = reviews) {
    const grid = document.getElementById('reviewsGrid');
    grid.innerHTML = reviewsToShow.map(review => `
      <div class="review-card">
        <div class="review-header">
          <div class="review-avatar ${review.avatarClass}">${review.avatar}</div>
          <div class="review-info">
            <h4>${review.name}</h4>
            <div class="review-meta">
              <span class="review-stars">${generateStars(review.rating)}</span>
            </div>
          </div>
        </div>
        
        <p class="review-text">${review.review}</p>
        
        <div>
          <span class="review-product">${review.product}</span>
          <div class="review-date">${review.date}</div>
        </div>

        <div class="review-footer">
          <div class="review-action">
            <span class="review-action-icon">👍</span>
            <span>Helpful</span>
          </div>
          <div class="review-action">
            <span class="review-action-icon">💬</span>
            <span>Reply</span>
          </div>
          <div class="review-action">
            <span class="review-action-icon">⋯</span>
            <span>More</span>
          </div>
        </div>
      </div>
    `).join('');
  }

  // Initial render
  renderReviews();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    const marginDesktopValue = this.getAttribute('data-margin-desktop');
    // Fetch data-margin-desktop and calculate percentage
    this.marginDesktopPercentage = parseFloat(marginDesktopValue) || 2; 
    this.marginDesktopThreshold = this.marginDesktopPercentage*2 / 100; 

    const marginMobileValue = this.getAttribute('data-margin-mobile');
    this.marginMobilePercentage = parseFloat(marginMobileValue) || 2; 
    this.marginMobileThreshold = this.marginMobilePercentage / 300; 

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollThreshold = 250; 
    const viewportWidth = window.innerWidth;
    let resetOffset;

    if (viewportWidth < 990) {
      resetOffset = window.innerHeight * this.marginMobileThreshold;
    } else {
      // Using desktop threshold
      resetOffset = window.innerHeight * this.marginDesktopThreshold;
    }
    
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > (this.headerBounds.bottom + scrollThreshold)) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > (this.headerBounds.bottom + scrollThreshold)) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top + resetOffset) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden');
    this.header.classList.remove('shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

  function initIntersectionObserver() {
  const headers = document.querySelectorAll('.enable-fixed-header-part--true.enable-header-full-width--false');

  if (!headers.length) return; // Ensure there are elements to observe

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target); 
      }
    });
  }, { threshold: 1 });

  headers.forEach(header => {
    observer.observe(header);
  });
}

initIntersectionObserver();

document.addEventListener('shopify:section:load', () => {
  initIntersectionObserver();
});


  } catch(e) { console.error(e); }
})();
})();
